<template>
  <div v-loading="loading">
    <div class="header-actions">
      <search-input
        placeholder="Поиск по ФИО"
        style="width: 300px"
        v-model="filters.search"
        @change="filtersChanged"
      >
      </search-input>
      <div slot="right">
        <div class="el-row--flex">
          <add-users-dialog
            :entity-type="$constants.visualQueryBuilder.formEntityTypes.TYPE_EVAL_PROFILE_USERS"
            :entity-id="$route.params.id"
            entity-report-key="users"
            delete-on-empty-search
            @after-save="createMembers"
          ></add-users-dialog>
        </div>
      </div>
    </div>
    <p>Найдено участников: {{ paginator ? paginator.totalCount : 0 }}</p>
    <div class="profile_users-block">
      <el-table :data="profile_users" border>
        <el-table-column width="150" prop="user.persnum" label="Перс. №"></el-table-column>
        <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
        <el-table-column prop="user.email" label="Email"></el-table-column>
        <el-table-column prop="user.position" label="Должность"></el-table-column>
        <el-table-column prop="user.subdivision" label="Подразделение"></el-table-column>
        <el-table-column prop="user.company" label="Компания"></el-table-column>
        <el-table-column width="90" align="center" label="Действия">
          <template v-slot="scope">
            <el-popconfirm
              confirm-button-text='Да'
              cancel-button-text='нет'
              icon="el-icon-question"
              title="Вы уверены, что хотите удалить участника с профиля?"
              @confirm="deleteProfileUser(scope.row)"
            >
              <el-button
                slot="reference"
                class="table-action-button"
                size="mini"
                round
                icon="far fa-trash-alt"
              >
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <paginator
      :paginator.sync="paginator"
      use-router-query-param
      @page-changed="loadProfileUsers"
    ></paginator>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import AddUsersDialog from "@/modules/evaluation/components/AddUsersDialog.vue";

export default {
  name: "profile-users",
  components: {AddUsersDialog, SearchInput, Paginator},
  data() {
    return {
      loading: false,
      profile_users: [],
      filters: {},
    }
  },
  mixins: [paginator],
  mounted() {
    this.loadProfileUsers();
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  methods: {
    createMembers() {
      this.loading = true;
      this.$api.evaluation.profileUserCreate({
        profile_id: this.$route.params.id,
      })
        .then(data => {
          this.loadProfileUsers();
        })
        .finally(() => {
          this.loading = false;
        })
    },
    loadProfileUsers() {
      this.loading = true;
      this.$api.evaluation.profileUserSearch({
        ...this.filters,
        expand: ['user'].join(),
        profile_id: this.$route.params.id,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.profile_users = data.profile_users;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteProfileUser(profileUser) {
      this.loading = true;
      this.$api.evaluation.profileUserDelete({
        ids: [profileUser.id],
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Пользователь с профиля успешно удален'
          });
        })
        .finally(() => {
          this.loadProfileUsers();
        })
    },
    filtersChanged() {
      this.loadProfileUsers();
    },
  }
}
</script>

<style lang="scss">
  .profile_users-block {
    margin: 25px 0;
  }

  .header-actions {
    display: flex;
    justify-content: space-between;
  }
</style>